// --
import React from 'react';
import classNames from 'classnames';

import "./TableCard.scss";
import AbstractReactComponent from "../AbstractReactComponent";

/**
 * Komponenta panelu - tabulky, který je na výšku 100% a má scrolovatelný pouze obsah, hlavička scrolovatelná není.
 */
class TableCard extends AbstractReactComponent {
    // TODO [R: dokumentace]
    static propTypes = {
        // header:
        // className:
        // detail
    };

    render() {
        const {detail, header, children, className} = this.props;

        const wrapperClassNames = classNames(
            className,
            "card-scrollable container-fluid card-table",
            {
                "card": !detail,
                "card-detail": detail,
            }
        );

        return <div className={wrapperClassNames}>
            {header && <div className="card-scrollable-header">{header}</div>}
            <div className="card-scrollable-content">
                {children}
            </div>
        </div>
    }
}

export default TableCard;
